<template>
  <div>
    <breadcrumb :items="breadcrumbItems" />

    <section class="classroom">
      <sala-aula-side-bar :modulos="modulos" :curso="curso" />

      <transition name="slide-fade" mode="out-in">
        <router-view @topicoChange="handleTopicoChange"></router-view>
      </transition>
    </section>

    <!-- Modal Comentário -->
    <div class="modal fade" id="modalComentario" tabindex="-1" role="dialog" aria-labelledby="modalComentarioLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalComentarioLabel">Comentário</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-conteudo">
            <div class="text-center">
              <!-- Conteúdo de vídeo -->
              <div class="my-3">
                <iframe width="100%" height="450" src="https://www.youtube.com/embed/w9I83rm4OPQ" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Breadcrumb from '@/core/components/Breadcrumb'
import SalaAulaSideBar from '@/modules/SalaAula/components/SalaAulaSideBar'
import CursoAPI from '@/api/cursos-api'
import { TipoTopicoUtil } from '@/core/types/tipo-topico-licao'
import ResponseUtils from '@/core/utils/response-utils'
import SalaAulaAPI from '@/api/sala-aula-api'

export default {
  name: 'SalaAulaApp',
  components: { SalaAulaSideBar, Breadcrumb },
  data () {
    return {
      breadcrumbItems: [],
      modulos: [],
      curso: {
        nome: '',
        progresso: 0,
        categoria: '',
        questoes: '',
        videos: '',
        horas: '',
        minutos: '',
        coordenador: '',
        referencia: '',
        idCurso: '',
        conteudo: '',
        cargaHoraria: null,
        parceiroNome: null,
        emitirCertificado: null
      }
    }
  },

  async beforeRouteEnter (to, from, next) {
    const curso = to.params.referenciaCurso
    const modulo = to.params.modulo
    const licao = to.params.licao
    const topico = to.params.topico
    if (curso || modulo || licao || topico) {
      const url = await SalaAulaAPI.identificarTopico(curso, modulo, licao, topico).then(data => data.url)

      if (url) {
        if (topico && url.includes(topico)) {
          next()
        } else if (url.startsWith('erro/')) {
          next({ name: 'not-found' })
        } else {
          window.location = `/${url}`
        }
      } else {
        next({ name: 'not-found' })
      }
    } else {
      next({ name: 'not-found' })
    }
  },

  mounted () {
    const loader = this.$loading.show()
    CursoAPI.obterDetalheEmenta(this.$route.params.referenciaCurso).then(data => {
      const curso = data.ementas
      this.curso.nome = curso.nome
      this.curso.idCurso = curso.id
      this.curso.referencia = curso.referencia
      this.curso.qntTopicos = data.qntTopicos
      this.curso.coordenador = (curso.coordenadores.length > 0) ? curso.coordenadores[0].nome : ''
      this.curso.cargaHoraria = curso.carga_horaria
      this.curso.emitirCertificado = curso.emitir_certificado
      this.curso.parceiroNome = curso.parceiroNome
      const modulos = curso.modulos
      const isHomeSalaAula = this.$route.path.endsWith(this.$route.params.referenciaCurso) || this.$route.path.endsWith(this.$route.params.referenciaCurso + '/')

      let urlInicial = ''

      modulos.forEach(modulo => {
        modulo.licoes.forEach(licao => {
          licao.topicos.forEach(topico => {
            const tipoTopico = TipoTopicoUtil.obterTipoTopicosPorId(topico.tipo)
            topico.href = `/sala-de-aula/${curso.referencia}/${modulo.referencia}/${licao.referencia}/${topico.referencia}`
            topico.tipoTopico = Object.assign({}, tipoTopico)

            if (urlInicial === '' && isHomeSalaAula && topico.concluido == null) {
              urlInicial = topico.href
            }
          })
        })
      })

      this.modulos = modulos

      if (urlInicial !== '') {
        this.$router.push(urlInicial)
      }

      CursoAPI.obterInformacaoCurso(curso.referencia).then(data => {
        this.curso.categoria = data.id_categoria
        this.breadcrumbItems = [
          { text: data.nome_categoria, href: data.ref_categoria ? `/categoria/${data.ref_categoria}` : null },
          { text: data.nome_disciplina, href: data.ref_disciplina ? `/disciplina/${data.ref_disciplina}` : null },
          { text: data.nome_curso, href: data.ref_curso ? `/cursos/detalhe/${data.ref_curso}` : null, active: true }
        ]
        this.$store.dispatch('defineNomeCurso', data.nome_curso)
      }).catch(() => {
        // Do nothing
      })

      SalaAulaAPI.obterTopico(this.$route.params.referenciaCurso, this.$route.params.modulo, this.$route.params.licao, this.$route.params.topico).then(conteudo => { this.curso.conteudo = conteudo })

      loader.hide()
    }).catch(error => ResponseUtils.handleError(error, loader))
  },
  methods: {
    handleTopicoChange: function (curso) {
      if (curso.progresso) {
        this.curso.progresso = curso.progresso
      }
    }
  }
}
</script>

<style scoped>
</style>
